// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__WG2+d","fullWidth":"Chip_fullWidth__t8Y8K","label":"Chip_label__xOD2l","gripIcon":"Chip_gripIcon__76+9t"};